import { combineReducers } from "redux";
import { reducer as toastrReducer } from 'react-redux-toastr'
import userSession from "./authentication/Reducer";
import settings from "./settings/Reducer";
import customers from "./customers/Reducer";
import users from "./users/Reducer";
import devices from "./devices/Reducer";
import regions from "./regions/Reducer";
import modems from "./modem-status/Reducer";
import accmodems from "./modems/Reducer";
import locations from "./locations/Reducer";
import reportData from "./reports/Reducer";
import features from "./features/Reducer";
import customerInfo from "./customer-info/Reducer";
import insuranceDetails from "./customer-insurance/Reducer";
import globalFeatures from "./global-features/Reducer";
import newCustomer from "./global-new-customer/Reducer";
import globalModemFirmware from "./global-modem-firmware/Reducer";
import globalReassingModem from "./global-reassign-modem/Reducer";
import langList from "./global-new-customer/Reducer";
import globalReassingDevice from "./global-reassign-device/Reducer";
import filetocloud from "./filetocloud/Reducer";


const Reducers = combineReducers({
  userSession,
  settings,
  toastr: toastrReducer,
  customers,
  users,
  devices,
  regions,
  modems,
  accmodems,
  locations,
  reportData,
  features,
  customerInfo,
  insuranceDetails,
  globalFeatures,
  newCustomer,
  globalModemFirmware,
  globalReassingModem,
  langList,
  globalReassingDevice,
  filetocloud

});

export default Reducers;
